import { createModel } from "@/orm/model";
import { belongsToIds, BelongsToIds, EntityRecord } from "@/orm/types";
import { OrganizationRecord } from "./organization";
import { Tag } from "./tag";
import { getUserDefaultRecordId } from "./user";

export type ContactDirectoryRecord = EntityRecord & {
  jobTitleTags: Tag[];
  belongsToOranizationIds: BelongsToIds<OrganizationRecord>;
};

export const contactDirectoryModel = createModel<ContactDirectoryRecord>({
  version: "1.0",
  collectionPath: "modelEntityRecordContactDirectory",
  labels: {
    singular: "Contact Directory",
    plural: "Contact Directories",
  },
  getDefaultRecord: () => ({
    belongsToOranizationIds: belongsToIds([]),
    jobTitleTags: [
      { id: "broker", label: "Broker", paletteId: "sunnyYellow" },
      { id: "investor", label: "Investor", paletteId: "lavender" },
      { id: "owner", label: "Owner", paletteId: "lipstick" },
      { id: "lender", label: "Lender", paletteId: "royalBlue" },
      { id: "qoe", label: "QoE", paletteId: "forestGreen" },
      { id: "attorney", label: "Attorney", paletteId: "mango" },
    ],
  }),
});

export const getDefaultContactDirectoryEntity = () => {
  return contactDirectoryModel.createEntityInstance({
    id: getUserDefaultRecordId(),
  });
};
